enum DocumentTypes {
    Audio = 'audio',
    Document = 'document',
    Video = 'video',
}

export default DocumentTypes;
